<template>
    <span>
        {{ labelText }}
    </span>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'long-term-booking-total-label',

        computed: {
            ...mapGetters('booking', [
                'monthlyDepositRequired',
                'isInstantMonthly',
                'seasonIntervalData',
            ]),

            labelText() {
                if (this.monthlyDepositRequired) {
                    if (this.isInstantMonthly) {
                        return 'Total Due Today (inc. deposit):';
                    }
                    return 'Deposit Due Today:';
                }
                return 'Total Due Today:';
            },
        },
    };
</script>
